import { Component } from '@angular/core';

@Component({
  selector: 'ag-crm-temp-react-host',
  templateUrl: './temp-react-host.component.html',
  styleUrls: ['./temp-react-host.component.scss'],
})
export class TempReactHostComponent {
}
